import { render, staticRenderFns } from "./VariantApprovingDialog.vue?vue&type=template&id=510701d7&scoped=true"
import script from "./VariantApprovingDialog.vue?vue&type=script&lang=js"
export * from "./VariantApprovingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510701d7",
  null
  
)

export default component.exports